import * as React from "react";
const SparePartsCatalogueView = React.lazy(() => import("./SparePartsCatalogueViewContainer"));

export { SparePartsCatalogueView };
